export enum ApiKeyPermission {
  BUNDLES_UPLOAD = "bundles:upload",
  SUPPORT_MCP_READ = "support-mcp:read",
}
